import get from 'lodash/get';

import { getPipelineVersionVariable } from 'common/api/v2/bitbucket';

import {
    FETCH_VERSION,
    FETCH_VERSION_SUCCESS,
    FETCH_VERSION_FAILURE,
} from '../actionTypes';
import { releaseNotificationActions } from '../reducer';

import setNewVersionAvailable from './setNewVersionAvailable';

const isLocalVersion = import.meta.env.VITE_VERSION === 'local-version';
const getLatestVersionNumbers = () => {
    if (isLocalVersion) return 0;
    return import.meta.env.VITE_VERSION.split('.')[2];
};

export default () => (dispatch) => {
    dispatch(releaseNotificationActions[FETCH_VERSION]());

    if (!import.meta.env.VITE_BITBUCKET_BUILD_VARIABLE_ID) return;

    getPipelineVersionVariable(import.meta.env.VITE_BITBUCKET_BUILD_VARIABLE_ID)
        .then((response) => {
            const { value } = response.data;
            dispatch(
                releaseNotificationActions[FETCH_VERSION_SUCCESS](
                    response.data,
                ),
            );
            const reactAppVersion = getLatestVersionNumbers();
            if (!isLocalVersion && parseInt(value) > parseInt(reactAppVersion))
                dispatch(setNewVersionAvailable(true));
        })
        .catch((error) =>
            dispatch(
                releaseNotificationActions[FETCH_VERSION_FAILURE](
                    get(error, 'data.errors', []),
                ),
            ),
        );
};
